/*********************** Custom JS for Boost AI Search & Discovery  ************************/
const boost_sd_customize = {
  update: (componentRegistry) => {
   
    // Update image Intrinsic size
    componentRegistry.useComponentPlugin('ProductImage', {
      name: 'Modify Images',
      enabled: true,
      apply: () => ({
        afterRender(element) {
          try {
            // Start customization--------------------------------------------
            let productData = element.getParentElm().getParams().props.data;
            let productId = productData.id;
            if (productData?.split_product) {
              productId = productData.variant_id;
            }
            let productItem = document.querySelector('[data-product-id="' + productId + '"]');
            productItem.querySelector(".boost-sd__product-image-img--main").setAttribute('sizes', '800px');
            productItem.querySelector(".boost-sd__product-image-img--second").setAttribute('sizes', '800px');
            // End-------------------------------------------------------------
          } catch (e) {
            console.error(e);
          }
        },
      }),
    });
  },
};

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  boost_sd_customize.update,
]);
